export default [
  /*** 管理员 开始 ***/
  {
    path: '/admin/list',
    component: () => import('../pages/admin/admin/index.vue'),
    meta: { title: '管理员管理' }
  },
  /*** 管理员 结束 ***/

  /*** 管理员组 开始 ***/
  {
    path: '/role/list',
    component: () => import('../pages/admin/adminRole/index.vue'),
    meta: { title: '管理角色管理' }
  },
  {
    path: '/role/rules',
    component: () => import('../pages/admin/adminRole/rules.vue'),
    meta: { title: '管理角色权限管理' }
  },
  /*** 管理员组 结束 ***/

  /*** 管理员权限 开始 ***/
  {
    path: '/rule/list',
    component: () => import('../pages/admin/adminRule/index.vue'),
    meta: { title: '管理权限管理' }
  },
  /*** 管理员权限 结束 ***/


  /*** 部门管理 开始 ***/
  {
    path: '/dept/list',
    component: () => import('../pages/admin/dept/index.vue'),
    meta: { title: '部门管理' }
  },
  /*** 部门管理 结束 ***/
]
